import React from 'react';
import { Row, Col } from 'reactstrap';

import usePatient from '~/utils/patient/hook';
import { UncontrolledTable } from '~/components';
import { format } from 'date-fns';
import { TableFilterDateRange, TableFilterIdentitySource } from '~/components/Filters';
import NoteCell from '~/components/Patient/Identity/NoteCell';
import { MatchStatus } from '~/utils/const/identity';

const ERAndUrgentCareVisits = () => {
  const [, { sacwisPersonId: sacwisId }] = usePatient();

  return (
    <UncontrolledTable
      name="er-and-urgent-care-visits"
      className="mx-4"
      endpoint={{
        url: 'data/public/list-view-cs-tbl-edvisits',
        params: {
          sacwisId,
          match_status_id: MatchStatus.Approved,
          'emergencyadmsntimeTs__<<': format(new Date(), 'MM/DD/YYYY'),
        },
    }}
      defaultSorted={[{ id: 'emergencyadmsntimeTs__>>', desc: true }]}
      columns={[{
      id: 'emergencyadmsntimeTs__>>',
      Header: 'Visit Date',
      accessor: 'attributes.emergencyadmsntimeTs',
      cellType: 'date',
      Filter: d => <TableFilterDateRange {...d} />,
    }, {
      id: 'cheifcomplaint',
      Header: 'Reason for Visit',
      accessor: 'attributes.cheifcomplaint',
    }, {
      id: 'eddisposition',
      Header: 'ED Disposition',
      accessor: 'attributes.eddisposition',
    }, {
      id: 'primarydx',
      Header: 'Primary Diagnosis',
      accessor: 'attributes.primarydx',
    }, {
      id: 'sourceDescription',
      Header: 'Reporting Healthcare Insitution',
      accessor: 'attributes.sourceDescription',
      Filter: d => <TableFilterIdentitySource {...d} />,
    }, {
      id: 'hasNotes',
      Header: 'Notes',
      accessor: 'attributes.hasNotes',
      filterable: false,
      Cell: d => (
        d.original.attributes.sourceDescription !== "Cincinnati Children's Medical Center"
          ? <NoteCell {...d} />
          : null
      ),
    }]}
      SubComponent={({ original: row }) => (
        <div className="p-3">
          <Row>
            <Col sm={2}>
              <h6 className="text-primary">Location</h6>
              {row.attributes.departmentname}
            </Col>

            <Col sm>
              <h6 className="text-primary">Additional Diagnosis</h6>
              {row.attributes.additionaldx ? row.attributes.additionaldx : 'none'}
            </Col>
          </Row>
        </div>
    )}
    />
  );
};

export default ERAndUrgentCareVisits;

